import { Component } from 'react';
import ReactSelect from '../../../../../components/ReactSelect';
import { getResponseApi } from './query';
import { withTranslation } from 'react-i18next';
import Loading from '../../../../../components/Loading';
import ReactSwiper from './ReactSwiper';

class Responses extends Component {
    constructor(props) {
        super(props);

        this.handleSelectPrompt = this.handleSelectPrompt.bind(this);

        this.state = {
            selectedPrompt: null,
            loader: false,
            responses: [],
        };
    }

    componentDidUpdate() {
        if (!this.state.selectedPrompt && this.props.project?.prompts?.length) {
            const firstPrompt = this.props.project.prompts[0];
            this.setState({ selectedPrompt: firstPrompt.prompt_uid });
            this.getResponses(firstPrompt.prompt_uid);
        }
    }

    async getResponses(prompt_uid) {
        try {
            this.setState({ loader: true });
            const res = await getResponseApi(prompt_uid);
            const data = await res.json();
            this.setState({ responses: data });
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({ loader: false });
        }
    }

    handleSelectPrompt(value) {
        this.setState({ selectedPrompt: value });
        this.getResponses(value);
    }

    render() {
        const { t } = this.props;
        const prompts = this.props.project?.prompts || [];

        const options = prompts.map((prompt) => ({
            value: prompt.prompt_uid,
            label: prompt.prompt,
        }));

        return (
            <div className="card rounded-main table-main overflow-hidden">
                <div className="card-header">
                    <h3 className="card-title">
                        {t('ai_tracking.keyword_detail.responses.header')}
                    </h3>
                </div>
                <div className="card-body">
                    <ReactSelect
                        options={options}
                        value={options.find((option) => option.value === this.state.selectedPrompt)}
                        onChange={this.handleSelectPrompt}
                        label={t('ai_tracking.keyword_detail.responses.selectPrompt')}
                        classname="mr-0"
                        isSearchable
                        blurInputOnSelect={true}
                        disabled={this.state.loader}
                    />

                    <div className="ai-tracking-responses">
                        {this.state.loader ? (
                            <Loading />
                        ) : this.state.responses?.length > 0 ? (
                            <div className="ai-tracking-responses-swiper">
                                <ReactSwiper responses={this.state.responses} />
                            </div>
                        ) : (
                            t('ai_tracking.keyword_detail.responses.no_responses_found')
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Responses);
